import { render } from "./RadioGroupComponent.vue?vue&type=template&id=6645749f"
import script from "./RadioGroupComponent.vue?vue&type=script&lang=js"
export * from "./RadioGroupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__